"use strict";
// payments.* contracts — the host-side interfaces behind the Payments plugin's
// extension points. Types only; implementations live in studio.
//
//   site Worker ──POST {purpose, ref, items?}──▶ studio payments.checkout
//        │                                          │ 1. purpose.price(ref)      (server-side price)
//        │                                          │ 2. pick provider (currency, features, mode)
//        │                                          │ 3. provider.createCheckout → redirect | modal
//        ◀──────────── CheckoutSession ─────────────┘
//   buyer pays at provider ──webhook──▶ provider.verifyWebhook → normalized event
//                                          │ amount/currency check → payment row pending→paid
//                                          │ purpose.onPaid(ref)  + emit payments.payment.succeeded@1
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurposeError = void 0;
class PurposeError extends Error {
    constructor(message, code = 'invalid_input') {
        super(message);
        this.code = code;
        this.name = 'PurposeError';
    }
}
exports.PurposeError = PurposeError;
